/**
 * Analytics utilities for FrogBox tracking
 */

/**
 * Check if we're in development mode
 */
function isDevelopment(): boolean {
  return import.meta.env?.MODE === 'development' || import.meta.env?.DEV === true;
}

/**
 * Tracks an analytics event
 *
 * In development mode, logs events to console.
 * In production mode, sends events to GA4 or configured analytics provider.
 *
 * @param name - Event name (use snake_case convention)
 * @param properties - Event properties/metadata
 */
export function trackEvent(
  name: string,
  properties?: Record<string, unknown>
): void {
  if (isDevelopment()) {
    console.log('[Analytics Event]', {
      event: name,
      ...properties,
      timestamp: new Date().toISOString(),
    });
    return;
  }

  try {
    // GA4/gtag integration
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', name, properties);
    }
  } catch (error) {
    // Silently fail - don't let analytics errors break the app
    console.error('[Analytics] Error tracking event:', error);
  }
}
